module.exports = __webpack_public_path__ + "1792771649312/fonts/Urbanist-Black.1a06966.ttf";